export default __webpack_public_path__ + "static/activewear-results-4-02e6be7c30fe108f6d7c71b2c3278aad.png";